import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import AppRoutes from './Routes';
 
 
import TopArrow from './components/TopArrow';

function App() {
  return (
    <div>
      <Router>
    
   
        <AppRoutes />
        <TopArrow />
  
      </Router>
    </div>
  );
}

export default App;
